import { render, staticRenderFns } from "./faces.vue?vue&type=template&id=2b9b0ddd"
import script from "./faces.vue?vue&type=script&lang=js"
export * from "./faces.vue?vue&type=script&lang=js"
import style0 from "./faces.vue?vue&type=style&index=0&id=2b9b0ddd&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports